import { T } from '@tribeplatform/react-components/i18n'

export const EmptyState = () => {
  return (
    <div className="grid grid-cols-1 gap-1">
      {[...Array(3)].map((_e, idx) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          className="flex space-s-3 items-center p-2 opacity-50"
        >
          <div className="rounded-avatar bg-skeleton h-10 w-10" />
          <div className="h-5 bg-skeleton rounded-full flex flex-grow" />
        </div>
      ))}
      <p className="text-sm p-2">
        <T
          id="Blocks.Leaderboard.WhenMembersAppear"
          defaultMessage="{MEMBERS_CC} will appear here once they start engaging in the {COMMUNITY}."
        />
      </p>
    </div>
  )
}
